import { Pipe, PipeTransform } from '@angular/core';
import { WeightUnitEnum } from '../../../enum/weight-unit.enum';

@Pipe({
    name: 'weight',
    standalone: true
})
export class WeightPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    if (args[0] === WeightUnitEnum.LB) {
      return value + 'lb';
    }
    if (args[0] === WeightUnitEnum.KG) {
      return value + 'kg';
    }
    return value;
  }

}
